import { Container } from "pixi.js";
import type { GameVisualAssets } from "../assets/GameVisualAssets";
import { BigWinView } from "../views/big-win/BigWinView";
import { FeatureFinishedView } from "../views/feature-finished/FeatureFinishedView";
import { FeatureTriggerView } from "../views/feature-trigger/FeatureTriggerView";
import { GameTransitionView } from "../views/game-transition/GameTransitionView";
import { GambleView } from "../views/gamble/GambleView";
import type { PresentationTaskRunner, SpineDriver, ViewportStore } from "@slot/presentation";
import type { LocalizationService } from "@slot/game-shell";

/**
 * `ModalLayer/GameModalContainer` — the round's modal overlays in scene order: feature trigger, big
 * win, feature finished, gamble, game transition. Every panel is
 * UI chrome: fades ride the chrome task runner, Spines are ticked by the shared `SpineDriver`.
 */
export class GameModals extends Container {
  public readonly featureTriggerView: FeatureTriggerView;
  public readonly bigWinView: BigWinView;
  public readonly featureFinishedView: FeatureFinishedView;
  public readonly gambleView: GambleView;
  public readonly gameTransitionView: GameTransitionView;

  public constructor(input: {
    assets: GameVisualAssets;
    localization: LocalizationService;
    /** UI-chrome runner (panel fades). */
    runner: PresentationTaskRunner;
    viewport: ViewportStore;
    spineDriver: SpineDriver;
  }) {
    super({ label: "GameModalContainer" });
    const overlayInput = {
      assets: input.assets,
      viewport: input.viewport,
      localization: input.localization,
      spineDriver: input.spineDriver,
      runner: input.runner,
    };
    this.featureTriggerView = new FeatureTriggerView(overlayInput);
    this.bigWinView = new BigWinView(overlayInput);
    this.featureFinishedView = new FeatureFinishedView(overlayInput);
    this.gambleView = new GambleView(overlayInput);
    this.gameTransitionView = new GameTransitionView();
    this.addChild(this.featureTriggerView, this.bigWinView, this.featureFinishedView, this.gambleView, this.gameTransitionView);
  }

  public dispose(): void {
    this.featureTriggerView.dispose();
    this.bigWinView.dispose();
    this.featureFinishedView.dispose();
    this.gambleView.dispose();
    this.destroy({ children: true });
  }
}
